import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintLogosInput,
    PrintLogos,
    UpdatePrintLogosInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PirntLogosService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPrintLogos(): Promise<PrintLogos[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintLogos
                })
            ).data.listPrintLogos.items;
            if (data) return data as PrintLogos[];
        } catch (error) {
            console.error('Error finding PrintLogos:', error);
            return null;
        }
    }
    async listPrintLogosByClient(clientId: string): Promise<PrintLogos[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ListPrintLogosByClient,
                    variables: {
                        clientId
                    }
                })
            ).data.ListPrintLogosByClient.items;
            if (data) return data as PrintLogos[];
        } catch (error) {
            console.error('Error finding PrintLogos:', error);
            return null;
        }
    }
    async createPrintLogos(input: CreatePrintLogosInput): Promise<PrintLogos> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintLogos,
                    variables: {
                        input
                    }
                })
            ).data.createPrintLogos;
            if (date) return date as PrintLogos;
        } catch (error) {
            console.error('Error creating PrintLogos:', error);
            return null;
        }
    }
    async UpdatePrintLogos(input: UpdatePrintLogosInput): Promise<PrintLogos> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintLogos,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintLogos;
            if (date) return date as PrintLogos;
        } catch (error) {
            console.error('Error update PrintLogos:', error);
            return null;
        }
    }
}
